import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";

import { AuthProvider } from "../../providers/auth/auth";
import { DatabaseProvider, patient, doctor } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import * as _ from "lodash";

import { PatientDetailsPage } from "../patient-details/patient-details";
import { PatientAddPage } from "../patient-add/patient-add";

import { Subject } from 'rxjs/Subject';
import { combineLatest } from 'rxjs/CombineLatest'

@IonicPage()
@Component({
  selector: "page-patients",
  templateUrl: "patients.html"
})
export class PatientsPage {

  public patientList: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;
  searchTerm: string;
  filteredpatients: any[];
  patients: any[];

  searchterm: string;
  allpatients;
 
  startAt = new Subject();
  endAt = new Subject();

  startobs = this.startAt.asObservable();
  endobs = this.endAt.asObservable();

  columnDefs = [
    {headerName: 'First Name', field: 'first_name' },
    {headerName: 'Last Name', field: 'last_name' },
    {headerName: 'DOB', field: 'dob' },
    {headerName: 'Gender', field: 'gender' },
    {headerName: 'Email', field: 'email' },
    {headerName: 'Phone', field: 'phone_number_primary' },

];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider
  ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database
        .getPatientsByClinic(this.clinic_id)
        .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        }).subscribe((patients) => {
          this.allpatients = patients;
          this.patients = patients;
        });
    });
  }

  goPatient() {
    this.navCtrl.push(PatientAddPage);
  }
  
  showPatientDetail(patient) {
    let patientdata = {
      patient: patient
    };
    this.navCtrl.push(PatientDetailsPage, patientdata);
  }

  filterItems(searchTerm) {
    return this.patients.filter(patient => {
      return (
        patient.full_name.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
      );
    });
  }

  setFilteredItems() {
    this.patients = this.allpatients;
    this.patients = this.filterItems(this.searchTerm);
  }

  resetPatients(val) {
    this.patients = this.allpatients
  }

}



// WEBPACK FOOTER //
// ./src/pages/patients/patients.ts